import { PRODDOMAIN } from "@/utils";
import axios from "axios";
import { GetServerSideProps } from "next";
import Head from "next/head";

const searchNode = (data: any, path: string) => {
  for (let i = 0; i < data?.length; i++) {
    const item = data[i];
    if (item.pathinfo === path) {
      return item;
    }

    if (item.childlist && Array.isArray(item.childlist)) {
      const found = searchNode(item.childlist, path) as any;
      if (found) {
        return found;
      }
    }
  }

  return null;
};

const getServerSideProps: GetServerSideProps = async context => {
  console.log('${PRODDOMAIN}');
  const lang = context.resolvedUrl.slice(0, 3) === '/en' ? 'en' : 'cn'
  const path = lang === 'cn' ? context.resolvedUrl : context.resolvedUrl.slice(3)

  const { data } = await axios.get(`${PRODDOMAIN}/api/menu?lang=${lang}`)
  const node = searchNode(data.data.menu_tree, path)

  const { data: _data } = await axios.get(`${PRODDOMAIN}/api/menu_info/${node?.id}`, {
    params: {
      lang
    }
  });

  return {
    props: {
      navDetail: _data.data || {},
    },
  };
};

const getHead = (navDetail: any) => {
  return (<Head>
    <title>{navDetail?.info?.meta_title || navDetail?.info?.name} </title>
    <meta name="keywords" content={navDetail?.info?.meta_kws} />
    <meta name="description" content={navDetail?.info?.meta_desc} />
    <script
          dangerouslySetInnerHTML={{
            __html: `
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?d88812b706e7e120a8177951b2a61433";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
    `,
          }}
        />
  </Head>)
}
export { getHead, getServerSideProps }
